
exports.XAxis = require('./XAxis');
exports.YAxis = require('./YAxis');



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/common/axes/index.js
// module id = 156
// module chunks = 0